<style lang="scss">

</style>
<template>
    <div >
        <Table :columns="podColumns" :data="podData" size="small" style="position: relative" max-height="400"></Table>
    </div>
</template>

<script>
import { HttpFuelDetailFile, HttpOneFileList } from '@/service/costbilling';
export default {
    props:['activeid'],
    data(){
        return {
            datajson:null,
            podData: [],
            modalProps: {
				show: false,
			},
        }
    },
    created(){
        HttpOneFileList({
            'search[EQ_downloadTaskId]':this.activeid
        }).then(res=>{
            this.podData = res.data.content
        })
    },
    computed: {
        podColumns(){
            return [
                {
                    title: 'trackingNo',
                    key: 'trackingNo',
                    width: 150,
                },
                {
                    title: 'fileUrl',
                    key: 'fileUrl',
                    render: (h, {row})=>{
                        return <a href={row.fileUrl} style={'color: #2d8cf0'}>{row.fileUrl}</a>
                    }
                },
            ];
        }
    },
    methods:{
    }
}
</script>
